import Page from '../../classes/Page'
import { app } from '../../utils/store'

import each from 'lodash/each'

export default class ArchiveAccessory extends Page{
    constructor(){
        super({
            id : 'archive_accessory',
            element: '[data-app-page]',
            // elements: { key : 'nodeElementSelector' }
        })

        this.url = new URL(window.location.href)
    }

    create() {
        super.create()

        if((this.url.searchParams.has('filter') && this.url.searchParams.get('filter') != "null")){
            this.filter = this.url.searchParams.get('filter')
            this.taxonomy = this.url.searchParams.get('taxonomy') // Remind to add 'Taxonomy' (without the PHP can't provide the right filtered page)
            this.createFilters() 
        }
    }

    createFilters = () => {
        each(app.language.select.children, (language) => {
            let link = language.querySelector('a.nav-link')

            link.href = `${link.href}?filter=${this.filter}&taxonomy=${this.taxonomy}`
        })
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}